const colors = {
  YELLOW: "#ffcc00",
  RED: "#d40511",
  GRAY: "#00000073"
};

export default colors;
